module.exports = require("@mui/material/locale");